import Vue from 'vue'
import Router from 'vue-router'

import routes from './routes'
import store from '../store';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes
});

router.beforeEach(async (to, from, next) => {   
    // Rotas públicas que não precisam de autenticação nem módulo
    const rotasPublicas = ['login', 'SelecionarModulo'];
    
    if (rotasPublicas.includes(to.name)) {
        next();
        return;
    }

    // Validar autenticação — o store pode estar vazio em reloads, usar localStorage como fallback
    const user = store.state.login.login;
    const usuarioLocalStorage = JSON.parse(localStorage.getItem('provedores-usuario') || 'null');
    const usuarioLogado = !!(user.name || usuarioLocalStorage?.name);

    if (!usuarioLogado) {
        next({ name: 'login' });
        return;
    }

    // Algum ancestral exige módulo ativo
    const requiresModule = to.matched.some(record => record.meta.requiresModule === true);
    // Rota (ou ancestral) declara explicitamente que dispensa módulo ativo
    const isExempt = to.matched.some(record => record.meta.requiresModule === false);
    const moduloAtivo = localStorage.getItem('moduloAtivo');

    if (requiresModule && !isExempt && !moduloAtivo) {
        next({ 
            name: 'SelecionarModulo',
            query: { redirect: to.fullPath }
        });
        return;
    }

    // Alguma rota exige um módulo específico
    const requiredModuloId = to.matched.reduce((acc, record) => record.meta.moduloId ?? acc, null);
    if (requiredModuloId !== null && moduloAtivo != requiredModuloId) {
        next({ name: 'dashboard' });
        return;
    }

    next();
});
  
export default router

